import { IndentValues } from "@/lib/utils/IndentValues";
import { Indent, Txt } from "@stenajs-webui/core";
import { Tooltip } from "@stenajs-webui/tooltip";

interface Props {
  tooltipLabel: string;
  value: string;
}

export const CellWithTooltip = ({ tooltipLabel, value }: Props) => {
  return (
    <Tooltip label={tooltipLabel} appendTo={document.body}>
      <Indent num={IndentValues.EIGHT}>
        <Txt style={{ fontWeight: "500" }}>{value}</Txt>
      </Indent>
    </Tooltip>
  );
};
